// 261010 SOTAIL (L39) — chữ của hộp «Plan phim mới» (THUẦN, không antd). Gom một chỗ để test được và không lọt chữ tiếng Anh trở lại.
export const CREATE_PLAN_LABELS = {
  title: 'Plan phim mới',
  okText: 'Tạo plan',
  cancelText: 'Huỷ',
  name: 'Tên plan',
  namePlaceholder: 'Để trống thì máy tự đặt tên',
  fromChapter: 'Từ chương',
  fromPlaceholder: 'Chương bắt đầu',
  fromRequired: 'Chọn chương bắt đầu',
  toChapter: 'Đến chương',
  toPlaceholder: 'Chương kết thúc',
  toRequired: 'Chọn chương kết thúc',
  aesthetic: 'Phong cách tham chiếu (không bắt buộc)',
  aestheticPlaceholder: 'Ví dụ: "neo-noir kiểu Fincher"',
  usedNote: 'Chương ghi «(đã dùng)» đã thuộc một plan khác nên bị khoá.',
  allUsedWarning: 'Các chương đó đều đã thuộc plan khác.',
  chaptersLoadFailed: (detail: string) => `Không tải được danh sách chương: ${detail}`,
} as const;

/** Hậu tố gắn vào nhãn chương đã nằm trong plan khác. */
export const CHAPTER_USED_SUFFIX = ' (đã dùng)';
